import { ZLocationType } from '@/entities/map'
import { cn } from '@/shared/lib'

export const getContent = ({
  name,
  type,
}: {
  name: string
  type: string | null
}) => {
  return `
      <div class="${cn('region-overlay', {
        state: type === ZLocationType.Enum.STATE,
      })}">
        ${name}
      </div>
    `
}
